module.exports = __webpack_public_path__ + "static/logo-style-3745d5de0728ec47786eb328c7076356.png";